import React from 'react';
import './CompositeFillingContent.css'; // Assuming you have a CSS file for styling


const PartialDenturesContent = () => {
  return (
    <div className="composite-fillings">
      <div className="composite-fillings-overview-container">
          <div className="composite-fillings-overview-info">
            <h2 className="composite-fillings-overview-header">Partial Dentures</h2>
            <div className="composite-fillings-custom-line"></div>
            <p className="composite-fillings-text">
            A denture is a removable dental appliance replacement for missing teeth and surrounding tissue.  They are made to closely resemble your natural teeth and may even enhance your smile.
            Partial dentures are used when one or more natural teeth remain in the upper or lower jaw.  A partial denture not only fills in the spaces created by missing teeth, it prevents other teeth from shifting.
            </p>
            <p className="composite-fillings-text">
              A complete denture may be either “conventional” or “immediate.”  A conventional type is made after the teeth have been removed and the gum tissue has healed, usually taking 4 to 6 weeks.  During this time the patient will go without teeth.  Immediate dentures are made in advance and immediately placed after the teeth are removed, thus preventing the patient from having to be without teeth during the healing process.  Once the tissues shrink and heal, adjustments will have to be made.
            </p>
          </div>

          <div className="composite-fillings-image-container">
            <img 
              src="/images/partial-dentures.jpeg" 
              alt="Composite Fillings" 
              className="composite-fillings-1"
            />
          </div>
      </div>

      <div className="composite-fillings-description-container">
        <div className="composite-fillings-reasons-container">
          <h3 className="composite-fillings-reasons-header">Reasons for Dentures</h3>
          <ul className="composite-fillings-reasons-list">
            <li>Complete Denture: loss of all teeth in an arch</li>
            <li>Partial Denture: loss of several teeth in an arch</li>
            <li>Enhancing smile and facial tissues</li>
            <li>Improving chewing, speech, and digestion</li>
          </ul>
        </div>

        <div className="composite-fillings-steps-container">
          <h3 className="composite-fillings-steps-header">What does getting dentures involve? </h3>
          <p className="composite-fillings-steps-text">
            The process of getting dentures requires several appointments, usually over several weeks.  Highly accurate impressions (molds) and measurements are taken and used to create your custom denture.  Several “try-in” appointments may be necessary to ensure proper shape, color, and fit.  At the final appointment, your dentist will precisely adjust and place the completed denture, ensuring a natural and comfortable fit.
          </p>
          <p className="composite-fillings-steps-text">
            It is normal to experience increased saliva flow, some soreness, and possible speech and chewing difficulty, however this will subside as your muscles and tissues get used to the new dentures.
            You will be given care instructions for your new dentures.  Proper cleaning of your new dental appliance, good oral hygiene, and regular dental visits will aid in the life of your new dentures.
          </p>
        </div>

      </div>
    </div>
  );
};


export default PartialDenturesContent;